import React, { useState, useEffect } from 'react';
import { Layout, Typography, Space, Tooltip, Dropdown, Menu } from 'antd';
import { 
  CrownFilled, 
  SettingFilled,
  BarChartOutlined,
  TrophyOutlined,
  LogoutOutlined,
  MenuOutlined,
  TeamOutlined,
} from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const { Header } = Layout;
const { Title, Text } = Typography;

const AppHeader = () => {
  
  const navigate = useNavigate();
  const [mobileView, setMobileView] = React.useState(window.innerWidth < 768);
  const userRole = localStorage.getItem('userRole');
  const userAreaId = localStorage.getItem('userAreaId');
  const userAreaName = localStorage.getItem('userAreaName');
  const username = localStorage.getItem('username');

  const handleLogout = async () => {

    const authToken = localStorage.getItem('authToken');
  
    try{
  
      if (authToken) {
  
        await axios.post(
          `${process.env.REACT_APP_API_URL}/logout`,
          {},
          {
            headers: {
              Authorization: `Bearer ${authToken}`
            }
          }
        );
  
      }
  
    }catch(error){
  
      console.error('Error cerrando sesión en el servidor:', error);
  
    }finally{
  
      localStorage.clear();
      navigate('/login');
  
    }
  
  };

  React.useEffect(() => {
    const handleResize = () => {
      setMobileView(window.innerWidth < 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);

  }, []);

  const isCaller = userRole === 'member' && userAreaId === '2';

  const menuItems = [
    {
      key: 'callers',
      icon: <BarChartOutlined />,
      label: 'Llamadores',
      onClick: () => navigate('/callers'),
      show: !isCaller && (userRole === 'admin' || userRole === 'moderator')
    },
    {
      key: 'ranking',
      icon: <TrophyOutlined />,
      label: 'Ranking',
      onClick: () => navigate('/ranking'),
      show: true
    },
    {
      key: 'settings',
      icon: <SettingFilled />,
      label: 'Configuración',
      show: userRole === 'admin'
    },
    {
      key: 'profile',
      icon: <CrownFilled />,
      label: 'Mi Perfil',
      onClick: () => navigate('/profile'),
      show: true
    },
    {
      key: 'logout',
      icon: <LogoutOutlined />,
      label: 'Cerrar Sesión',
      onClick: () => {
        localStorage.clear();
        navigate('/login');
      },
      show: true
    }
  ].filter(item => item.show).map(({ show, ...rest }) => rest);

  return ( 
    <Header style={{
      background: 'linear-gradient(135deg, #2a2b2b 0%, #353435 100%)',
      padding: mobileView ? '0 12px' : '0 24px',
      height: '64px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      boxShadow: '0 2px 8px rgba(0, 0, 0, 0.45)',
      borderBottom: '1px solid #f49b33'
    }}>
      <div 
        style={{ 
          display: 'flex', 
          alignItems: 'center',
          cursor: 'pointer'
        }}
        onClick={() => navigate('/')}
      >
        <CrownFilled style={{ 
          color: '#f49b33', 
          fontSize: mobileView ? '20px' : '24px',
          marginRight: mobileView ? '8px' : '12px'
        }} />
        
        <div>
          <Title level={mobileView ? 4 : 3} style={{ 
            color: '#fff', 
            margin: 0,
            fontWeight: 600,
            letterSpacing: '0.5px',
            whiteSpace: 'nowrap'
          }}>
            LION <span style={{ color: '#f49b33' }}>BUILDINGS</span>
          </Title>
          {userAreaName && (
            <Text style={{ 
              color: '#aaa', 
              fontSize: mobileView ? '12px' : '14px',
              display: 'block',
              marginTop: '-4px'
            }}>
              {username}
            </Text>
          )}
        </div>
      </div>
      
      {mobileView ? (
        <Dropdown
          overlay={
            <Menu items={menuItems} theme="dark" />
          }
          trigger={['click']}
          placement="bottomRight"
        >
          <MenuOutlined style={{ 
            color: '#f49b33', 
            fontSize: '20px',
            cursor: 'pointer'
          }} />
        </Dropdown>
      ) : (
        <Space size="large">
          {!isCaller && (
            <Tooltip title="Llamadores">
              <BarChartOutlined 
                style={{ 
                  color: '#f49b33', 
                  fontSize: '18px', 
                  cursor: 'pointer' 
                }} 
                onClick={() => navigate('/callers')} 
              />
            </Tooltip>
          )}

          <Tooltip title="Ranking">
            <TrophyOutlined 
              style={{ 
                color: '#f49b33', 
                fontSize: '18px', 
                cursor: 'pointer' 
              }} 
              onClick={() => navigate('/ranking')} 
            />
          </Tooltip>
          
          <Dropdown
            menu={{
              items: [{
                key: 'profile',
                icon: <CrownFilled />,
                label: 'Mi Perfil',
                onClick: () => navigate('/profile')
              },
              ...(userRole === 'admin' ? [{
                key: 'team',
                icon: <TeamOutlined />,
                label: 'Team',
                onClick: () => navigate('/team_list')
              }] : []),
              {
                key: 'logout',
                icon: <LogoutOutlined />,
                label: 'Cerrar Sesión',
                onClick: handleLogout,
                show: true
              }]
            }}
            placement="bottomRight"
          >
            <SettingFilled 
              style={{ 
                color: '#f49b33', 
                fontSize: '18px', 
                cursor: 'pointer' 
              }} 
            />
          </Dropdown>
        </Space>
      )}

    </Header>
  );
};

export default AppHeader;